import { render, staticRenderFns } from "./PropertyHeader.vue?vue&type=template&id=69d89dee&scoped=true"
import script from "./PropertyHeader.vue?vue&type=script&lang=js"
export * from "./PropertyHeader.vue?vue&type=script&lang=js"
import style0 from "./PropertyHeader.vue?vue&type=style&index=0&id=69d89dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d89dee",
  null
  
)

export default component.exports